import './condition-builder.scss';
import { observer } from "mobx-react-lite";
import ConditionBuilderStore from "../../../../../stores/condition-builder-store";
import { ButtonIcon } from '../../../../../../../components/inputs/button-icon/button-icon';
import IconDelete from '../../../../../../../components/icons/icon-delete/icon-delete';
import ConditionFieldSelector from './condition-field-selector/condition-field-selector';
import ConditionField from './condition-field/condition-field';
import PolicyConditionGroupStore from '../../../../../stores/policy-condition-group-store';
import IconEdit from '../../../../../../../components/icons/icon-edit/icon-edit';
import IconApply from '../../../../../../../components/icons/icon-apply/icon-apply';
import IconDiscard from '../../../../../../../components/icons/icon-discard/icon-discard';
import { TOOLTIP_VARIANTS, Tooltip } from '../../../../../../../components/tooltip/tooltip';
import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../../../components/fonts/font-props';
import Icon from '../../../../../../../components/icons/icon/icon';
import IconInfo from '../../../../../../../components/icons/icon-info/icon-info';
import { CONDITION_ERROR } from '../../../../../policy-types';

export interface IProps {
    conditionIndex: number;
    conditionGroup: PolicyConditionGroupStore;
    condition: ConditionBuilderStore;
}

const ConditionBuilder: React.FC<IProps> = observer(({
    conditionIndex,
    condition
}) => {
    /** next 2 methods can be refactored into one, returning object like {iconColor: string, tooltipVariant: TOOLTIP_VARIANTS} */
    const getTooltipVariant = (): TOOLTIP_VARIANTS => {
        if (!condition.error) {
            throw new Error('Can not get tooltip variant if there is no error');
        }

        switch (condition.error.type) {
            case CONDITION_ERROR.DUPLICATED:
                return TOOLTIP_VARIANTS.WARNING;
            default:
                return TOOLTIP_VARIANTS.ERROR;
        }
    };

    const getTooltipColor = (): string => {
        if (!condition.error) {
            throw new Error('Can not get tooltip color if there is no error');
        }

        switch (condition.error.type) {
            case CONDITION_ERROR.DUPLICATED:
                return 'var(--color-accent-4)';
            default:
                return 'var(--color-accent-3)';
        }
    };

    const IconInfoComponent = () => <IconInfo color={getTooltipColor()} />;
    const group = condition.conditionGroupStore;

    return (
        <div className={`condition-builder ${(!condition.isEditMode && !!condition.error) && condition.error.type}`}>
            <div className='condition-builder-content'>
                <ConditionFieldSelector
                    conditionIndex={conditionIndex}
                    condition={condition}
                />
                {condition.field && <ConditionField condition={condition} />}
            </div>
            <div className='condition-builder-buttons'>
                {(condition.isEditMode && condition.error) &&
                    <Tooltip variant={getTooltipVariant()} content={<div style={{ maxWidth: '200px' }}>
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            {condition.error.body}
                        </FontBody2>
                    </div>}>
                        <Icon Component={IconInfoComponent} />
                    </Tooltip>
                }
                {condition.isEditMode
                    ? <>
                        <ButtonIcon Component={() => <IconDiscard color={`var(--color-accent-3)`} />} onClick={() => group.discardUncommittedChanges(condition) }/>
                        <ButtonIcon Component={() => <IconApply color={`var(--color-primary-1)`} />} onClick={() => group.tryCommitChanges(condition) }/>
                    </>
                    : <>
                        <ButtonIcon Component={() => <IconDelete color={`var(--color-accent-1)`} />} onClick={() => group.deleteCondition(condition)} />
                        <ButtonIcon Component={() => <IconEdit color={`var(--color-accent-1)`} />} onClick={() => group.setIsEditMode(condition, true)} />
                    </>
                }
            </div>
        </div>
    )
});

export default ConditionBuilder;
